
import XHeader from 'vux/src/components/x-header/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Loading from 'vux/src/components/loading/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {
getArticleList
} from '../../api/public'

export default {
name: 'HomeIndex',
directives: {
TransferDom
},
components: {
XHeader,
Search,
Swiper,
Flexbox,
FlexboxItem,
Loading,
XDialog
},
data () {
return {
title: '潮州侨联',

searchResult: null,
searchValue: '',

swiperList: null,
swiperIndex: 0,

articleList: null,
articleIndex: 0,
userIdentity: null,

showLoading: true,
loadingText: '加载中',
isFloatPic: false
}
},
created () {
this.getArticleList()
},
methods: {
getArticleList () {
getArticleList().then(res => {
this.articleList = res.data
this.showLoading = false
})
},

onSwiperIndexChange (index) {
this.swiperIndex = index
}
}
}



// WEBPACK FOOTER //
// ./src/components/home/index.vue